import { i18n } from "../../globalization/i18n.js";
import { Control } from "../Control.js";

export class ComponentWrapper extends Control {

    constructor(parent, params = {}) {

        params = Object.assign({
            component: null,
            componentParams: null,
            componentPrepared: false,
        }, params || {});

        super(parent, params);

        let component = this.getComponent();

        const that = this;

        if (component && component.prepare && (typeof component.prepare == 'function')) {
            component.prepare(that.componentParams)
                .then(function () {
                    that.componentPrepared = true;
                    that.invalidate();
                });
        }

        return this;

    }

    getComponent() {

        return (typeof this.component == 'function') ? this.component.call(this) : this.component;

    }

    _render(r, vm) {

        const renderer = r;

        if (!this.componentPrepared) {
            return renderer.el('div', 'panel padding text-center', {}, [
                renderer.icon('spinner', 'fa-pulse'),
                ' ',
                i18n.t('ui.label.loading_in_progress')
            ]);
        }

        let component = this.getComponent();

        if (!component) {
            return renderer.el('div', 'text-center', {}, ['[ ERR: Component not found! ]']);
        }

        return component.render(renderer, vm);

    }

}